var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('TitleBar'),(!_vm.is_logged_in)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('Login')],1)]):_c('main',{staticClass:"home"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }